// Leave a placeholder untouched when its variable is missing (e.g. a preview
// with no inherited country picked) instead of printing "undefined".
export const injectLabelVariables = (label = '', variables = {}) => {
    let result = label;
    if (variables.countryName != null) {
        result = result.replace('{{country}}', variables.countryName);
    }
    if (variables.countryCode != null) {
        result = result.replace('{{country_code}}', variables.countryCode);
    }
    return result;
};
